<div class="min-h-screen bg-[#F3F4F6] dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">

  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">จัดการ Subscription</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        ตั้งค่า Subscription ตามลาน
        <span class="text-amber-600 font-bold"> — ลาน: {{ selectedSiteName || 'กรุณาเลือกลาน' }}</span>
      </p>
    </div>
    <div class="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
      <button type="button" (click)="onRefresh()"
        class="w-full sm:w-auto p-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 transition-all flex items-center justify-center h-[46px]">
        <span class="material-icons">refresh</span>
      </button>
      <button *ngIf="canCreate" type="button" (click)="openCreate()"
        class="w-full sm:w-auto px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl shadow-lg flex items-center justify-center gap-2 h-[46px]">
        <span class="material-icons text-xl">add_circle</span>
        เพิ่ม Subscription
      </button>
    </div>
  </div>

  <div class="bg-white dark:bg-slate-800 rounded-3xl shadow border border-slate-100 dark:border-slate-700 overflow-hidden relative">
    <app-pss-loading *ngIf="isLoading()"></app-pss-loading>

    <div class="p-6 border-b border-slate-100 dark:border-slate-700 flex flex-wrap items-center justify-between gap-3">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">subscriptions</span>
        รายการ Subscription
      </h3>
      <div class="flex gap-2 items-center w-full sm:w-auto">
        <input type="text" [ngModel]="searchText()" (ngModelChange)="searchText.set($event)"
          (keyup.enter)="onSearch()" placeholder="ค้นหาชื่อ..." [disabled]="!selectedSiteId"
          class="flex-1 sm:w-64 px-4 py-2 rounded-xl border bg-slate-50 dark:bg-slate-900 dark:border-slate-700 text-sm disabled:opacity-50">
        <button type="button" (click)="onSearch()" [disabled]="!selectedSiteId"
          class="px-4 py-2 rounded-xl bg-slate-100 dark:bg-slate-700 text-sm font-bold disabled:opacity-50">ค้นหา</button>
      </div>
    </div>

    <div class="overflow-x-auto min-h-[280px]">
      <table class="w-full text-left text-sm">
        <thead class="bg-slate-50 dark:bg-slate-800/50 text-xs uppercase text-slate-400">
          <tr>
            <th class="px-6 py-4">ID</th>
            <th class="px-6 py-4">ชื่อ</th>
            <th class="px-6 py-4">Identify</th>
            <th class="px-6 py-4 text-center">Calc. Category</th>
            <th class="px-6 py-4 text-center">Calc. Type</th>
            <th class="px-6 py-4 text-right">จำนวนเงิน</th>
            <th class="px-6 py-4">Fee</th>
            <th class="px-6 py-4">Rate</th>
            <th class="px-6 py-4">Gate Group</th>
            <th class="px-6 py-4">ประเภทรถ</th>
            <th class="px-6 py-4">หมายเหตุ</th>
            <th class="px-6 py-4 text-center">Online</th>
            <th class="px-6 py-4 text-center">จอดฟรี</th>
            <th class="px-6 py-4 text-center">จัดการ</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items()" class="border-t border-slate-100 dark:border-slate-800 hover:bg-slate-50/50 dark:hover:bg-slate-800/30">
            <td class="px-6 py-4 text-slate-400">{{ item.id }}</td>
            <td class="px-6 py-4 font-semibold">{{ item.name }}</td>
            <td class="px-6 py-4 font-mono text-xs">{{ item.identify || '-' }}</td>
            <td class="px-6 py-4 text-center tabular-nums">{{ item.calculateCategory ?? '-' }}</td>
            <td class="px-6 py-4 text-center tabular-nums">{{ item.calculateType ?? '-' }}</td>
            <td class="px-6 py-4 text-right">{{ item.fee | number:'1.2-2' }}</td>
            <td class="px-6 py-4">{{ item.feeName || '-' }}</td>
            <td class="px-6 py-4">{{ item.rateName || '-' }}</td>
            <td class="px-6 py-4">{{ item.gateGroupName || '-' }}</td>
            <td class="px-6 py-4">{{ item.vehicleTypeName || '-' }}</td>
            <td class="px-6 py-4 text-xs text-slate-500 max-w-[180px] truncate" [title]="item.remark">{{ item.remark || '-' }}</td>
            <td class="px-6 py-4 text-center">
              <span class="text-xs font-bold" [ngClass]="item.isOnline ? 'text-emerald-600' : 'text-slate-400'">
                {{ item.isOnline ? 'ใช่' : 'ไม่' }}
              </span>
            </td>
            <td class="px-6 py-4 text-center">
              <span class="text-xs font-bold" [ngClass]="item.isFreeParking ? 'text-sky-600' : 'text-slate-400'">
                {{ item.isFreeParking ? 'ใช่' : 'ไม่' }}
              </span>
            </td>
            <td class="px-6 py-4 text-center">
              <button *ngIf="canUpdate" type="button" (click)="openEdit(item)"
                class="p-2 rounded-lg hover:bg-amber-50 dark:hover:bg-amber-900/20 text-amber-600">
                <span class="material-icons text-[18px]">edit</span>
              </button>
            </td>
          </tr>
          <tr *ngIf="!isLoading() && items().length === 0">
            <td colspan="14" class="px-6 py-16 text-center text-slate-400">
              {{ selectedSiteId ? 'ไม่พบ Subscription ของลานนี้' : 'กรุณาเลือกลานจาก Sidebar' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-700 flex flex-col md:flex-row items-center justify-between gap-4">
      <div class="flex items-center gap-4 text-sm text-slate-500 font-medium">
        <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems() | number }} รายการ</span>
        <select (change)="onPageSizeChange($event)" [ngModel]="pageSize()"
          class="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-lg font-bold px-2 py-1 outline-none focus:ring-2 focus:ring-amber-200">
          <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
        </select>
      </div>
      <div class="flex items-center gap-2">
        <button type="button" (click)="setPage(currentPage() - 1)" [disabled]="currentPage() === 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer bg-transparent">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button type="button" *ngFor="let p of pagesArray" (click)="setPage(p)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all cursor-pointer border-none"
          [ngClass]="p === currentPage() ? 'bg-amber-400 text-white shadow-sm' : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 bg-transparent'">
          {{ p }}
        </button>
        <button type="button" (click)="setPage(currentPage() + 1)"
          [disabled]="currentPage() === totalPages() || totalPages() === 0"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer bg-transparent">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-parking-subscription *ngIf="isModalOpen()" [editRow]="selectedItem()"
  [siteId]="selectedSiteId" [siteName]="selectedSiteName"
  (close)="closeModal()" (saveSuccess)="onSaved()"></app-modal-parking-subscription>
